var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "tenant-submission-documents",
      attrs: { id: "tenant-project-documents" },
    },
    [
      _c("div", { staticClass: "section-header" }, [
        _c("span", { staticStyle: { "margin-right": "auto" } }, [
          _vm._v(" " + _vm._s(_vm.$t("tenantProjects.projectDocuments"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tenant-project-doc__title--duration" },
          [
            _c("span", { staticClass: "lable" }, [
              _vm._v(_vm._s(_vm.$t("showLabel")) + ":"),
            ]),
            _vm._v(" "),
            _c("HKLSelect", {
              attrs: {
                value: _vm.currentBatchFilter.value,
                options: _vm.documentHklOptions,
                dropdownClassName: "tenant-project-doc__batch-dropdown",
                placeholder: "",
              },
              on: { change: _vm.onBatchFilterChange },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "section-content" }, [
        _vm.enableUpload
          ? _c("div", { staticClass: "section-desc" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("tenantProjects.projectDocDesc")) +
                  "\n    "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "file-attachments" }, [
          _c(
            "div",
            { staticClass: "contents" },
            [
              _vm.enableUpload
                ? _c("HkldDropzone", {
                    ref: "hkldDropzone1",
                    attrs: {
                      sourceId: _vm.projectDocsSrcId,
                      maxNumberOfFiles: 20,
                      autoProcess: false,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "column-header clearfix" }, [
                _vm.isShowUserSubmitBtn()
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn--orange",
                        on: { click: _vm.openSubmitConfirm },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("tenantProjects.submitForReview")) +
                            "\n          "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "titles" }, [
                  _vm.isEngineer || _vm.isRetail
                    ? _c(
                        "span",
                        { staticClass: "flex-left" },
                        [
                          _c(
                            "span",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.doSort(_vm.docTypeAttrs[0])
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("tenantProjects.design")))]
                          ),
                          _vm._v(" "),
                          _c("popover", {
                            attrs: {
                              text: _vm.$t("tenantProjects.designDocsTip"),
                              position: "bottom-right",
                              width: 300,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isEngineer || _vm.isRetail
                    ? _c(
                        "span",
                        { staticClass: "flex-middle" },
                        [
                          _c(
                            "span",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.doSort(_vm.docTypeAttrs[1])
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("tenantProjects.technical")))]
                          ),
                          _vm._v(" "),
                          _c("popover", {
                            attrs: {
                              text: _vm.$t("tenantProjects.techDocsTip"),
                              position: "bottom-left",
                              width: 300,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isEngineer
                    ? _c("span", { staticClass: "flex-right" }, [
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.doSort(_vm.docTypeAttrs[2])
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("excluded")))]
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _vm._l(_vm.projectDocsSrcIdFiles, function (file, index) {
                return [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFile(file),
                          expression: "isShowFile(file)",
                        },
                      ],
                      key: index,
                      class: [
                        "file-panel",
                        { "yellow-bg": _vm.isShowYellowBg(file) },
                        { "red-bg": file.metaData.isNotValidate },
                      ],
                    },
                    [
                      _c("div", { staticClass: "panel" }, [
                        _c(
                          "a",
                          {
                            staticClass: "download-link tender-font",
                            on: {
                              click: function ($event) {
                                return _vm.downloadFile(file.id)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(file.filename) +
                                "\n              "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.allowChangeName[file.id],
                                expression: "allowChangeName[file.id]",
                              },
                            ],
                          },
                          [
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: file.description,
                                  expression: "file.description",
                                },
                                { name: "autosize", rawName: "v-autosize" },
                                {
                                  name: "checkVisibility",
                                  rawName: "v-checkVisibility",
                                  value: { refresh: true },
                                  expression: "{refresh: true}",
                                },
                              ],
                              staticClass: "doc-desc__textarea tender-font",
                              attrs: { autofocus: "" },
                              domProps: { value: file.description },
                              on: {
                                focusout: function ($event) {
                                  return _vm.updateDescription(file)
                                },
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    file,
                                    "description",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.allowChangeName[file.id],
                                expression: "!allowChangeName[file.id]",
                              },
                            ],
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "desc-text",
                                on: {
                                  dblclick: function () {
                                    return (
                                      _vm.canEditDesciption(file) &&
                                      _vm.Vue.set(
                                        _vm.allowChangeName,
                                        file.id,
                                        true
                                      )
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      file.description ||
                                        (!_vm.deep(file, "metaData.submitted")
                                          ? _vm.$t("project.docs.fillDescHint")
                                          : "")
                                    ) +
                                    "\n                "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.canEditDesciption(file)
                              ? _c("i", {
                                  class: [
                                    "fa fa-pencil icon",
                                    { "no-drop": _vm.isBeforeBatchNum(file) },
                                  ],
                                  on: {
                                    click: function () {
                                      return _vm.Vue.set(
                                        _vm.allowChangeName,
                                        file.id,
                                        true
                                      )
                                    },
                                  },
                                })
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.deep(file, "metaData.submitted")
                          ? _c("p", { staticClass: "updator-text" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t("submittedByOn", [
                                      _vm.findCreatorName(file),
                                    ])
                                  ) +
                                  "\n                "
                              ),
                              _c("span", { staticClass: "update-date" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.dateUtil.format(
                                      _vm.deep(file, "metaData.submittedDate"),
                                      "DD MMM YY"
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "update-date" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.dateUtil.format(
                                      _vm.deep(file, "metaData.submittedDate"),
                                      "HH:mm"
                                    )
                                  )
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "panel" }, [
                        _c("div", { staticClass: "choose-file-type" }, [
                          _vm.isEngineer || _vm.isRetail
                            ? _c("div", { staticClass: "half flex-left" }, [
                                _c("input", {
                                  attrs: {
                                    type: "checkbox",
                                    disabled: _vm.disableTypeChange(file),
                                  },
                                  domProps: { checked: file.metaData.isDesign },
                                  on: {
                                    change: function ($event) {
                                      return _vm.changeFileTypeDesign(file)
                                    },
                                  },
                                }),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isEngineer || _vm.isRetail
                            ? _c("div", { staticClass: "half flex-middle" }, [
                                _c("input", {
                                  attrs: {
                                    type: "checkbox",
                                    disabled: _vm.disableTypeChange(file),
                                  },
                                  domProps: {
                                    checked: file.metaData.isTechnical,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.changeFileTypeTechnical(file)
                                    },
                                  },
                                }),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isEngineer
                            ? _c("div", { staticClass: "half flex-right" }, [
                                _c("input", {
                                  attrs: {
                                    type: "checkbox",
                                    disabled: _vm.disableTypeChange(file),
                                  },
                                  domProps: { checked: file.metaData.isNa },
                                  on: {
                                    change: function ($event) {
                                      return _vm.changeFileTypeNa(file)
                                    },
                                  },
                                }),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.deep(file, "metaData.submitted") &&
                          file.metaData.uploadBy === _vm.currentUser.id
                            ? _c("i", {
                                staticClass: "fa fa-times fa-lg",
                                on: {
                                  click: function ($event) {
                                    return _vm.openDeleteConfirm(
                                      file,
                                      _vm.projectDocsSrcIdFiles
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _vm.deep(file, "metaData.updator.displayName")
                          ? _c("p", { staticClass: "updator-text" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t("tenantProjects.updatedBy", [
                                      _vm.deep(
                                        file,
                                        "metaData.updator.displayName"
                                      ),
                                    ])
                                  ) +
                                  "\n                "
                              ),
                              _c("span", { staticClass: "update-date" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.dateUtil.format(
                                      _vm.deep(file, "metaData.updatedDate"),
                                      "DD MMM YY"
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "update-date" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.dateUtil.format(
                                      _vm.deep(file, "metaData.updatedDate"),
                                      "HH:mm"
                                    )
                                  )
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "batch-number" }, [
                        !_vm.isEmpty(file.batchNum) &&
                        _vm.isShowBatchStamp(file)
                          ? _c("span", { staticClass: "batch-icon" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t(
                                      "tenantProjects.tenantViewComments.batchNumber",
                                      [Number(file.batchNum) + 1]
                                    )
                                  ) +
                                  "\n              "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.isWithdrawn &&
                        _vm.isEngineer &&
                        _vm.isCurrentTechReviewer &&
                        _vm.isEmpty(file.batchNum) &&
                        _vm.hasPendingSubmission &&
                        _vm.deep(file, "metaData.submitted")
                          ? _c(
                              "span",
                              {
                                staticClass: "add-batch-link",
                                on: {
                                  click: function ($event) {
                                    return _vm.addToBatch(file)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t("tenantProjects.addToBatch")
                                    ) +
                                    "\n              "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ]
                  ),
                ]
              }),
            ],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("ActionConfirmModal", {
        ref: "submitConfirmModal",
        attrs: {
          modalId: _vm.submConfModalId,
          confirmTitle: _vm.$t("confirmSubmit"),
        },
      }),
      _vm._v(" "),
      _c("ActionConfirmModal", {
        ref: "deleteConfirmModal",
        attrs: {
          modalId: _vm.deleConfModalId,
          confirmTitle: _vm.$t("deleteConfirmMsg"),
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }